export const BLACK_MODAL_BACKGROUND_STYLE = { backgroundColor: '#000000' };
